import { render, staticRenderFns } from "./ttshop_invoice.vue?vue&type=template&id=a51ac12c&scoped=true&"
import script from "./ttshop_invoice.vue?vue&type=script&lang=js&"
export * from "./ttshop_invoice.vue?vue&type=script&lang=js&"
import style0 from "./ttshop_invoice.vue?vue&type=style&index=0&id=a51ac12c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a51ac12c",
  null
  
)

export default component.exports